import { SocialIcon } from 'react-social-icons';
function Footer(props) {
    return (<h1 className="footer">
      <SocialIcon className="icons" url="https://www.linkedin.com/in/kunhyuk-lee-ab2281237" />
      <SocialIcon className="icons" url="https://github.com/kunhyuk" />

      </h1>)
  }
  
  export default Footer;